/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import StyledTableCell from '../../components/StyledTableCell';
import TableBody from '@material-ui/core/TableBody';
import StyledTableRow from '../../components/StyledTableRow';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import WrapperContent from './WrapperContent';
import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import CurrencyFormat from 'react-currency-format';

import AppDialog from '../../components/AppDialog';
import { formatDate } from '../../modules/utils';
import { getFullPicture } from '../../modules/imageHandler';
import { useDispatch, useSelector } from 'react-redux';
import { SELECTOR_ORDERS_CURRENT } from '../../redux/selectors/orders';
import { addNotification, getOrderById } from '../../redux/actions';
import Button from '@material-ui/core/Button';
import { removeOrderDetail, updateOrder, updateOrderDetail } from '../../redux/actions/orders';
import { SELECTOR_USER } from '../../redux/selectors/auth';
import { ShoppingBasket } from '@material-ui/icons';
import { createCartFromOrderId } from '../../redux/actions/shoppingCart';

function OrderDetailRowEdit({
  accessActions,
  deleteOrderDetail,
  handleOpenShippingDetails,
  item,
  updateQuantityOrderDetail,
}) {
  const [edit, setEdit] = useState(false);
  const [quantity, setQuantity] = useState(item.quantity);

  return (
    <>
      <StyledTableCell align="center" compact secondaryBorders>
        <img style={{ maxHeight: 60 }} src={getFullPicture(item.product_main_image)} alt={''} />
      </StyledTableCell>
      <StyledTableCell align="center" secondaryBorders>
        <Typography color="textPrimary" variant="inherit">
          {item.product_name}
        </Typography>
      </StyledTableCell>
      <StyledTableCell align="center" secondaryBorders>
        {edit ? <input type={'number'} value={quantity} onChange={(e) => {
          const v = e.target.value;
          if (v >= 1) setQuantity(v);
          else setQuantity(1);
        }} /> : quantity}
      </StyledTableCell>
      <StyledTableCell align="center" secondaryBorders>
        {item.sent}
      </StyledTableCell>
      <StyledTableCell align="center" secondaryBorders>
        {item.shippings_details.map((item) => (
          <Link onClick={() => handleOpenShippingDetails(item)}>{item.shipping_id}&nbsp;-&nbsp;</Link>
        ))}
      </StyledTableCell>
      {accessActions && (
        <StyledTableCell align="center" secondaryBorders>
          <Box clone mr={3}>
            <IconButton
              size={'small'}
              onClick={() => {
                setEdit(!edit);
                if (edit) {
                  updateQuantityOrderDetail(item.id, Number(quantity));
                }
              }}
            >
              {edit ? <SaveIcon /> : <EditIcon />}
            </IconButton>
          </Box>
          {!edit && (
            <IconButton
              size={'small'}
              onClick={() => {
                deleteOrderDetail(item.id);
              }}
            >
              <DeleteIcon />
            </IconButton>
          )}
        </StyledTableCell>
      )}
      <StyledTableCell align="center" secondaryBorders>
        <CurrencyFormat
          value={Math.trunc(item.total_price_tax_incl - item.total_price_tax)}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'$'}
          renderText={(value) => <Typography style={{ fontSize: 14 }}>{value}</Typography>}
        />
      </StyledTableCell>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  table: {
    border: '0.5px solid rgba(122,122,122, 0.2)',
  },
  tableContainer: {
    borderRadius: 10,
    // overflow: 'hidden'
  },
  title: {
    fontWeight: 600,
    fontSize: '1.rem',
    marginTop: theme.spacing(3),
  },
  card: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    '& > span': {
      lineHeight: 1.9,
      textTransform: 'capitalize',
    },
  },
  wrapperCards: {
    borderRadius: 10,
    border: '0.5px solid rgba(122,122,122, 0.2)',
  },
  button: {
    paddingLeft: 0,
  },
  status: {
    fontSize: '.8rem',
    lineHeight: '36px',
    fontWeight: 700,
  },
  image: {
    maxHeight: 60,
  },
  detailButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  tableProductDetails: {
    float: 'right',
    '& > span': {
      lineHeight: 1.4,
      textTransform: 'capitalize',
    },
  },
  tableCaption: {
    border: '0.5px solid rgba(122,122,122, 0.2)',
    padding: 5,
  },
}));

function OrdersDetail() {
  const [open, setOpen] = useState(false);
  const [shipping, setShipping] = useState({});

  const session = useSelector(SELECTOR_USER);
  const order = useSelector(SELECTOR_ORDERS_CURRENT);
  const history = useHistory();

  const classes = useStyles();
  const dispatch = useDispatch();
  const match = useRouteMatch('/mi-cuenta/mis-pedidos/:id');

  const accessActions = useMemo(
    () => session?.owner_company === 'true' && order?.status?.status_code === 'order_needs_approval',
    [session?.id, order?.id],
  );

  useEffect(() => {
    if (match?.params?.id) {
      loadData();
    }
  }, [match?.params?.id]);

  const handleOpenShippingDetails = (item) => {
    setOpen(true);
    let currentShipping = order.shippings.find(({ id }) => id === item.shipping_id);
    setShipping(currentShipping);
  };

  function loadData() {
    dispatch(getOrderById(Number(match?.params?.id))).catch((e) => {
      // if (e.code === 404) history.push("/mi-cuenta/mis-pedidos");
      history.push('/mi-cuenta/mis-pedidos');
      if (e.code !== 404) dispatch(addNotification(e.message, 'error'));
    });
  }

  function deleteOrderDetail(id) {
    dispatch(removeOrderDetail(id)).then(() => {
      loadData();
    });
  }

  function updateQuantityOrderDetail(id, quantity) {
    dispatch(updateOrderDetail(id, quantity))
      .then(() => {
        loadData();
      })
      .catch((e) => {
        dispatch(addNotification(e.message, 'error'));
      });
  }

  if (!order?.id) {
    return <div />;
  }

  return (
    <WrapperContent>
      <Box display="flex" gridGap={12} justifyContent="space-between" alignItems="center">
        <div>
          <Box display="flex" gridGap={10} alignItems="center">
            <Typography color="primary" className={classes.title}>
              Pedido Nro. {order.id}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Typography className={classes.status}>
              Creado por: {order.user?.first_name} {order.user?.last_name}
            </Typography>
          </Box>
        </div>

        {[3, 5, 6, 7, 8, 9].includes(order.order_status_id) && (
          <div>
            <Button
              variant="outlined"
              size="small"
              color="secondary"
              onClick={() => {
                dispatch(createCartFromOrderId(order.id))
              }}
            >
              <ShoppingBasket />
            </Button>
          </div>
        )}
      </Box>
      <Box clone my={2}>
        <Divider />
      </Box>
      <Box mb={10} clone>
        <Grid container spacing={5}>
          <Grid item>
            <Typography className={classes.status}>Estado actual: {order.status.name}</Typography>
          </Grid>
        </Grid>
      </Box>
      <Box mb={5}>
        <Grid container spacing={9}>
          <Grid item xs={12} md={4}>
            <Box className={classes.wrapperCards}>
              <Box className={classes.card}>
                <Box mb={1} clone>
                  <Typography variant="subtitle2">Información de envio: </Typography>
                </Box>
                <Typography variant="overline">{order.company.name}</Typography>
                <Typography variant="overline">{JSON.parse(order.shipping_address_meta_data).name}</Typography>
                <Typography variant="overline">{JSON.parse(order.shipping_address_meta_data).address}</Typography>
                <Typography variant="overline">Teléfono: {order?.user?.phone}</Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <TableContainer className={classes.tableContainer}>
              <Table className={classes.table} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell disableHeadBorders>Estado</StyledTableCell>
                    <StyledTableCell disableHeadBorders>Fecha</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {order.history.map((item) => (
                    <StyledTableRow disableColor key={item.id.toString()}>
                      <StyledTableCell secondaryBorders component="th" scope="row">
                        <Typography color="textPrimary" variant="inherit">
                          {item.name}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell secondaryBorders>
                        <Typography color="textPrimary" variant="inherit">
                          {formatDate(item.createdAt)}
                        </Typography>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
        <Box mt={6}>
          <Grid container>
            <Grid xs={12}>
              <TableContainer className={classes.tableContainer}>
                <Table className={classes.table} aria-label="customized table">
                  <caption className={classes.tableCaption}>
                    <Box display="inline-flex" flexDirection="column" className={classes.tableProductDetails}>
                      <Typography align="right" variant="overline" color="textPrimary" style={{ marginBottom: 3 }}>
                        Subtotal:{' '}
                        <CurrencyFormat
                          value={Math.trunc(order.total_price_shipping_cost_excl - (order.total_tax || 0))}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          renderText={(value) => <span>{value}</span>}
                        />
                      </Typography>
                      <Typography align="right" variant="overline" color="textPrimary" style={{ marginBottom: 3 }}>
                        Valor envío:{' '}
                        <CurrencyFormat
                          value={order.total_shipping_cost || 0}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          renderText={(value) => <span>{value}</span>}
                        />
                      </Typography>
                      {order.discount_shipping_cost_amount && (
                        <Typography align="right" variant="overline" color="textPrimary" style={{ marginBottom: 3 }}>
                          Descuento de envío:{' '}
                          <CurrencyFormat
                            value={order.discount_shipping_cost_amount || 0}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            renderText={(value) => <span>- {value}</span>}
                          />
                        </Typography>
                      )}
                      {!!order.discount_total_amount && (
                        <Typography align="right" variant="overline" color="textPrimary" style={{ marginBottom: 3 }}>
                          Descuento:{' '}
                          <CurrencyFormat
                            value={order.discount_total_amount || 0}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                            renderText={(value) => <span>{value}</span>}
                          />
                        </Typography>
                      )}
                      <Typography align="right" variant="overline" color="textPrimary" style={{ marginBottom: 3 }}>
                        IVA:{' '}
                        <CurrencyFormat
                          value={Math.trunc(order.total_tax)}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          renderText={(value) => <span>{value}</span>}
                        />
                      </Typography>
                      <Typography align="right" variant="body2" color="primary">
                        Total:{' '}
                        <CurrencyFormat
                          value={Math.trunc(order.total_price)}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          renderText={(value) => <span>{value}</span>}
                        />
                      </Typography>
                    </Box>
                  </caption>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell align="center" disableBackground secondaryBorders>
                        Producto
                      </StyledTableCell>
                      <StyledTableCell align="center" disableBackground secondaryBorders>
                        Nombre
                      </StyledTableCell>
                      <StyledTableCell align="center" disableBackground secondaryBorders>
                        Cantidad comprada
                      </StyledTableCell>
                      <StyledTableCell align="center" disableBackground secondaryBorders>
                        Cantidad enviada
                      </StyledTableCell>
                      <StyledTableCell align="center" disableBackground secondaryBorders>
                        Envios asociados
                      </StyledTableCell>
                      {accessActions && (
                        <StyledTableCell align="center" disableBackground secondaryBorders>
                          Acciones
                        </StyledTableCell>
                      )}
                      <StyledTableCell align="center" disableBackground secondaryBorders>
                        Valor
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {order.order_details.map((item) => (
                      <StyledTableRow disableColor key={item.id.toString()}>
                        <OrderDetailRowEdit
                          accessActions={accessActions}
                          deleteOrderDetail={deleteOrderDetail}
                          handleOpenShippingDetails={handleOpenShippingDetails}
                          item={item}
                          updateQuantityOrderDetail={updateQuantityOrderDetail}
                        />
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12}>
              {order.status.id === 11 && session.owner_company === 'true' && (
                <div
                  style={{
                    marginTop: 15,
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Button
                    variant="outlined"
                    size="small"
                    color="primary"
                    onClick={() => {
                      dispatch(updateOrder(order.id, { order_status_id: 3 }));
                    }}
                  >
                    Aprobar pedido
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    variant="outlined"
                    size="small"
                    color="secondary"
                    onClick={() => {
                      dispatch(updateOrder(order.id, { order_status_id: 12 }));
                    }}
                  >
                    Rechazar pedido
                  </Button>
                </div>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
      <AppDialog handleClose={() => setOpen(false)} open={open}>
        <Box mt={6} mb={4} mx={4}>
          <Box mb={3}>
            <Typography>Transportadora: {shipping?.fulfillment_company?.name}</Typography>
            {shipping?.delivery_number && <Typography>Guia: {shipping.delivery_number}</Typography>}
            <Typography>Fecha de envio: {formatDate(shipping?.createdAt)}</Typography>
          </Box>
          <TableContainer>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Producto</TableCell>
                  <TableCell align="right">Cantidad enviada</TableCell>
                </TableRow>
              </TableHead>
              {shipping?.shipping_details && (
                <TableBody>
                  {shipping.shipping_details.map(({ order_detail: { product_name, sent }, quantity }) => (
                    <TableRow key={product_name}>
                      <TableCell component="th" scope="row">
                        {product_name}
                      </TableCell>
                      <TableCell align="right">{quantity}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Box>
      </AppDialog>
    </WrapperContent>
  );
}

export default OrdersDetail;
